import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DISPLAY_LANG } from "../config";
import { errorMessage } from "../api/global"
import Loading from "../components/loading";
import axios from "../axios";
import '../stylesheets/sslPage.css';

const headingText = {
  en: "SSL Certificates",
  am: "SSL Վկայագրեր",
  ru: "SSL Сертификаты"
};

const subHeadingText = {
  en: "From Global Brands",
  am: "Համաշխարհային բրենդերից",
  ru: "От мировых брендов"
};

const tariffPlansText = {
  en: "Guarantee of secure data exchange between the site and its visitors",
  am: "Կայքի և նրա այցելուների միջև տվյալների անվտանգ փոխանակման երաշխիք",
  ru: "Гарантия безопасного обмена данными между сайтом и его посетителями"
};

const noLoginAlertText = {
  en: "Please log in to view SSL certificate details.",
  am: "Խնդրում ենք մուտք գործել՝ տեսնելու SSL վկայագրի մանրամասները։",
  ru: "Пожалуйста, войдите в систему, чтобы просмотреть детали SSL сертификата."
};

export default function SSLPage() {
  const navigate = useNavigate();
  const [logoImage, setLogoImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadingData = async () => {
      try {
        const res = await axios.get("ssl/sll_image");
        setLogoImage(res.data.data);
      } catch (error) {
        console.log(error);
        alert(errorMessage[DISPLAY_LANG])
      } finally {
        setLoading(false);
      }
    };

    loadingData();
    window.scrollTo(0, 0);
  }, []);

  const handleBrandClick = (brand) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert(noLoginAlertText[DISPLAY_LANG]);
      sessionStorage.setItem("redirectAfterLogin", `/user/ssl/${brand}`);
      navigate("/user/login");
      return;
    }

    navigate(`/user/ssl/category/${brand}`);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="SSLPage wrapper">
      <h1 className="heading">{headingText[DISPLAY_LANG]}</h1>

      <div className="ssl-brands">
        {logoImage.map((el) => (
          <div
            className="ssl-brand-card"
            key={el.id}
            onClick={() => handleBrandClick(el.brand_image_name)}
          >
            <img
              src={el.image_url}
              alt={`${el.brand_image_name} SSL Certificate Brand`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
